import {batchActions} from 'redux-batch-enhancer'
import {
  getOrderedTimePeriodRanges,
  getAggregatedSites,
  getConverionType
} from 'redux/modules/currentUser/selectors'
import {CALL_API, Call} from 'redux/middleware/api'
import {reportError} from 'redux/modules/error/actions'
import {
  DASHBOARD_PROJECTION,
  DASHBOARD_CURRENT_TOTAL,
  DASHBOARD_PREVIOUS_TOTAL,
  DASHBOARD_CURRENT_TOTAL_NEW,
  DASHBOARD_PREVIOUS_TOTAL_NEW,
  DASHBOARD_TABLE,
  DASHBOARD_TABLE_TOTAL,
  DASHBOARD_TRAFFIC,
  DASHBOARD_LAST_ORDERS
} from './'
import formatDateWithTz from 'utils/formatDateWithTz'
const statsVersion = localStorage.getItem('statsVersion') === 'v1' ? '' : 'v2/'

function loadDashboardDataChart({
  merchantSiteId,
  startDate,
  endDate,
  targetCurrency,
  timezone,
  conversionType
}) {
  return {
    [CALL_API]: {
      endpoint: `${statsVersion}stats`,
      types: DASHBOARD_PROJECTION,
      queryParams: {
        'range[start]': startDate,
        'range[end]': endDate,
        merchantSiteId,
        metrics: [
          'session:count',
          'order:count-non-direct-last-click',
          'order:ftdCount-non-direct-last-click',
          'order:regCount-non-direct-last-click',
          'order:total',
          'cost:total'
        ],
        timeUnit: 'day',
        targetCurrency,
        timezone,
        // conversionType
      }
    }
  }
}

function loadDashboardTotal(
  {
    merchantSiteId,
    startDate,
    endDate,
    targetCurrency,
    timezone,
    conversionType
  },
  types
) {
  return {
    [CALL_API]: {
      endpoint: `${statsVersion}stats`,
      types,
      queryParams: {
        'range[start]': startDate,
        'range[end]': endDate,
        merchantSiteId,
        metrics: [
          'order:count-non-direct-last-click',
          'order:ftdCount-non-direct-last-click',
          'order:regCount-non-direct-last-click',
          'order:total',
          'cost:total'
        ],
        timeUnit: 'total',
        targetCurrency,
        timezone
      }
    }
  }
}
function loadDashboardTable(
  {
    merchantSiteId,
    startDate,
    endDate,
    targetCurrency,
    timezone,
    conversionType
  },
  types
) {
  const metrics = [
    'order:count-every-session',
    'order:count',
    'order:count-last-click',
    'order:count-touchpoint',
    'order:count-non-direct-last-click',
    'order:count-non-direct-clicks',
    'order:count-non-direct-touch',
    'order:count-non-direct-last-touch'
  ]
  const metricsSorting = metrics.reduce((acc, m) => {
    acc[m] = 'desc'
    return acc
  }, {})
  return {
    [CALL_API]: {
      endpoint: `${statsVersion}stats`,
      types: DASHBOARD_TABLE,
      queryParams: {
        'range[start]': startDate,
        'range[end]': endDate,
        merchantSiteId,
        dimensions: ['channelGroup', 'channel'],
        metrics,
        sort: metricsSorting,
        timeUnit: 'total',
        targetCurrency,
        timezone,
        conversionType
      }
    }
  }
}
function loadDashboardTableTotal(
  {merchantSiteId, startDate, endDate, targetCurrency, timezone},
  types
) {
  const metrics = [
    'order:count',
    'order:count-last-click',
    'order:total-divvit'
  ]
  const metricsSorting = metrics.reduce((acc, m) => {
    acc[m] = 'desc'
    return acc
  }, {})
  return {
    [CALL_API]: {
      endpoint: `${statsVersion}stats`,
      types: DASHBOARD_TABLE_TOTAL,
      queryParams: {
        'range[start]': startDate,
        'range[end]': endDate,
        merchantSiteId,
        sort: metricsSorting,
        metrics,
        timeUnit: 'total',
        targetCurrency,
        timezone
      }
    }
  }
}

function loadOrderCountByGroup({
  merchantSiteId,
  startDate,
  endDate,
  timezone,
  conversionType
}) {
  return {
    [CALL_API]: {
      endpoint: `${statsVersion}stats`,
      types: DASHBOARD_TRAFFIC,
      queryParams: {
        'range[start]': startDate,
        'range[end]': endDate,
        merchantSiteId,
        dimensions: ['channelGroup'],
        metrics: ['session:count', 'order:count'],
        timeUnit: 'day',
        timezone,
        conversionType
      }
    }
  }
}

function loadLastOrders({merchantSiteId}) {
  const fetchParams = {merchantSiteId}
  return {
    [CALL_API]: {
      endpoint: 'Orders/mostRecentByChannelGroup',
      types: DASHBOARD_LAST_ORDERS,
      queryParams: fetchParams
    }
  }
}

export function fetchDashboardDataNew(crossSiteMode, targetCurrency, timezone) {
  return (dispatch, getState) => {
    const state = getState()
    const sites = getAggregatedSites(state, crossSiteMode)
    const conversionType = getConverionType(state)
    const {start, end, switched} = getOrderedTimePeriodRanges(state)

    const fetchParams = {
      merchantSiteId: sites,
      conversionType,
      targetCurrency,
      startDate: formatDateWithTz(end.start, timezone),
      endDate: formatDateWithTz(start.end, timezone),
      timezone
    }

    const currentTotalAction = switched
      ? DASHBOARD_PREVIOUS_TOTAL_NEW
      : DASHBOARD_CURRENT_TOTAL_NEW
    const currentPreviousAction = switched
      ? DASHBOARD_CURRENT_TOTAL_NEW
      : DASHBOARD_PREVIOUS_TOTAL_NEW

    if (crossSiteMode) {
      return Call.all([
        dispatch(loadDashboardDataChart(fetchParams)),
        dispatch(
          loadDashboardTotal(
            {
              ...fetchParams,
              startDate: formatDateWithTz(start.start, timezone),
              endDate: formatDateWithTz(start.end, timezone)
            },
            currentTotalAction
          )
        ),
        dispatch(
          loadDashboardTotal(
            {
              ...fetchParams,
              startDate: formatDateWithTz(end.start, timezone),
              endDate: formatDateWithTz(end.end, timezone)
            },
            currentPreviousAction
          )
        ),
        dispatch(
          loadDashboardTable(
            {
              ...fetchParams,
              startDate: formatDateWithTz(start.start, timezone),
              endDate: formatDateWithTz(start.end, timezone)
            },
            currentTotalAction
          )
        )
      ]).fail(dispatch(reportError()))
    } else {
      return Call.all(
        dispatch(
          batchActions([
            loadDashboardDataChart(fetchParams),
            loadDashboardTotal(
              {
                ...fetchParams,
                startDate: formatDateWithTz(start.start, timezone),
                endDate: formatDateWithTz(start.end, timezone)
              },
              currentTotalAction
            ),
            loadDashboardTotal(
              {
                ...fetchParams,
                startDate: formatDateWithTz(end.start, timezone),
                endDate: formatDateWithTz(end.end, timezone)
              },
              currentPreviousAction
            ),
            loadDashboardTable(
              {
                ...fetchParams,
                startDate: formatDateWithTz(start.start, timezone),
                endDate: formatDateWithTz(start.end, timezone)
              },
              currentTotalAction
            )
            // loadLastOrders(fetchParams)
          ])
        )
      ).fail(dispatch(reportError()))
    }
  }
}
export function fetchDashboardData(crossSiteMode, targetCurrency, timezone) {
  return (dispatch, getState) => {
    const state = getState()
    const sites = getAggregatedSites(state, crossSiteMode)
    const {start, end, switched} = getOrderedTimePeriodRanges(state)

    const fetchParams = {
      merchantSiteId: sites,
      targetCurrency,
      startDate: formatDateWithTz(end.start, timezone),
      endDate: formatDateWithTz(start.end, timezone),
      timezone
    }

    const currentTotalAction = switched
      ? DASHBOARD_PREVIOUS_TOTAL
      : DASHBOARD_CURRENT_TOTAL
    const currentPreviousAction = switched
      ? DASHBOARD_CURRENT_TOTAL
      : DASHBOARD_PREVIOUS_TOTAL

    if (crossSiteMode) {
      return Call.all([
        dispatch(loadDashboardDataChart(fetchParams)),
        dispatch(
          loadDashboardTotal(
            {
              ...fetchParams,
              startDate: formatDateWithTz(start.start, timezone),
              endDate: formatDateWithTz(start.end, timezone)
            },
            currentTotalAction
          )
        ),
        dispatch(
          loadDashboardTotal(
            {
              ...fetchParams,
              startDate: formatDateWithTz(end.start, timezone),
              endDate: formatDateWithTz(end.end, timezone)
            },
            currentPreviousAction
          )
        )
      ]).fail(dispatch(reportError()))
    } else {
      return Call.all(
        dispatch(
          batchActions([
            loadDashboardDataChart(fetchParams),
            loadDashboardTotal(
              {
                ...fetchParams,
                startDate: formatDateWithTz(start.start, timezone),
                endDate: formatDateWithTz(start.end, timezone)
              },
              currentTotalAction
            ),
            loadDashboardTotal(
              {
                ...fetchParams,
                startDate: formatDateWithTz(end.start, timezone),
                endDate: formatDateWithTz(end.end, timezone)
              },
              currentPreviousAction
            ),
            loadOrderCountByGroup(fetchParams),
            loadLastOrders(fetchParams)
          ])
        )
      ).fail(dispatch(reportError()))
    }
  }
}



// WEBPACK FOOTER //
// ./client/redux/modules/dashboard/actions.js